import { c as _c } from "react/compiler-runtime";
import type { TransformedDocument } from '@/entity/hooks/use-documents';
import useDocuments from '@/entity/hooks/use-documents';
export const parseDocumentIdentifier = (documentIdentifier: string) => {
  const match = documentIdentifier.match(/^(.*):(\d+)$/);
  if (!match) return null;
  const version = Number(match[2]);
  if (!Number.isSafeInteger(version)) return null;
  return {
    identifier: match[1],
    version
  };
};
export const findDocumentUpload = (documents: TransformedDocument[] | undefined, documentIdentifier: string): {
  document: TransformedDocument;
  upload: TransformedDocument['uploads'][number];
} | null => {
  for (const document of documents ?? []) {
    const upload = document.uploads.find(candidate => `${candidate.identifier}:${candidate.version}` === documentIdentifier);
    if (upload) return {
      document,
      upload
    };
  }
  return null;
};
const useVaultDocument = (entityId, documentIdentifier) => {
  const $ = _c(14);
  let t0;
  if ($[0] !== documentIdentifier) {
    t0 = parseDocumentIdentifier(documentIdentifier);
    $[0] = documentIdentifier;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const parsedIdentifier = t0;
  const current = useDocuments(entityId ?? "");
  let t1;
  if ($[2] !== current.data || $[3] !== documentIdentifier) {
    t1 = findDocumentUpload(current.data, documentIdentifier);
    $[2] = current.data;
    $[3] = documentIdentifier;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const currentMatch = t1;
  const shouldFetchHistorical = current.isSuccess && !currentMatch && !!parsedIdentifier;
  const historical = useDocuments(shouldFetchHistorical ? entityId ?? "" : "", parsedIdentifier?.version);
  let t2;
  if ($[5] !== documentIdentifier || $[6] !== historical.data) {
    t2 = findDocumentUpload(historical.data, documentIdentifier);
    $[5] = documentIdentifier;
    $[6] = historical.data;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const historicalMatch = t2;
  const t3 = currentMatch ?? historicalMatch;
  const t4 = parsedIdentifier?.version;
  const t5 = current.isPending || shouldFetchHistorical && historical.isPending;
  const t6 = current.error ?? historical.error;
  const t7 = current.isSuccess && !currentMatch && (!parsedIdentifier || historical.isSuccess && !historicalMatch);
  let t8;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = {
      match: t3,
      version: t4,
      isLoading: t5,
      error: t6,
      isUnavailable: t7
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default useVaultDocument;